import { z } from "zod";
import { email, objectId } from "./common.js";
/**
 * Password policy.
 *
 * Length is the dominant factor, so the floor is 10 rather than the customary 8, with a
 * light character-class requirement to stop "1234567890". Deliberately no maximum below
 * 128 and no forced rotation — both push users toward weaker, reused secrets.
 */
export const password = z
    .string()
    .min(10, "Password must be at least 10 characters")
    .max(128, "Password must be at most 128 characters")
    .refine((v) => /[a-z]/.test(v), "Include at least one lowercase letter")
    .refine((v) => /[A-Z]/.test(v), "Include at least one uppercase letter")
    .refine((v) => /\d/.test(v), "Include at least one number");
export const loginSchema = z.object({
    email,
    password: z.string().min(1, "Password is required"),
});
export const changePasswordSchema = z
    .object({
    currentPassword: z.string().min(1, "Enter your current password"),
    newPassword: password,
    confirmPassword: z.string(),
})
    .refine((v) => v.newPassword === v.confirmPassword, {
    message: "The passwords do not match",
    path: ["confirmPassword"],
})
    .refine((v) => v.newPassword !== v.currentPassword, {
    message: "The new password must be different from the current one",
    path: ["newPassword"],
});
export const resetPasswordSchema = z
    .object({
    userId: objectId,
    newPassword: password,
    confirmPassword: z.string(),
    /** Force the user to set their own password at next login. Default true. */
    mustChange: z.boolean().default(true),
})
    .refine((v) => v.newPassword === v.confirmPassword, {
    message: "The passwords do not match",
    path: ["confirmPassword"],
});
//# sourceMappingURL=auth.js.map